import React from 'react';
import { Route, IndexRoute } from 'react-router';
import App from './App';
import Base from './containers/Base';
import Main from './containers/Main';
import Auth from './containers/Auth';

import Login from './components/Auth/Login';
import Logout from './components/Auth/Logout';
import Signup from './components/Auth/Signup';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import ConfirmEmail from './components/Auth/ConfirmEmail';
import ResendVerificationLink from './components/Auth/ResendVerificationLink';

import NotFound from './pages/NotFound';
import DevExample from './pages/DevExample';
import PaymentTest from './pages/PaymentTest';

import Dashboard from './pages/Dashboard';
import Agreements from './pages/Agreements';
import User from './pages/User';
import Teams from './pages/Teams';
import CreateTeam from './components/Teams/CreateTeam';
import TeamDetail from './components/Teams/TeamDetail';
import AgreementDetail from './components/Agreements/AgreementDetail';
import AgreementDetailSplitUpdate from './components/Agreements/AgreementDetailSplitUpdate';
import Password from './pages/Password';

import Create from './pages/Create';
import ProductType from './components/Create/ProductType';
import ProductProps from './components/Create/ProductProps';
import SelectTeam from './components/Create/SelectTeam';
import SelectAgreement from './components/Create/SelectAgreement';
import CreateAgreementOwnershipSplit from './components/Agreements/CreateAgreementOwnershipSplit';
import CreateAgreementOwnershipPremiumSplit from './components/Agreements/CreateAgreementOwnershipPremiumSplit';
import CreateAgreementSoundRecordingSplitType from './components/Agreements/CreateAgreementSoundRecordingSplitType';
import CreateAgreementOwnershipPercentage from './components/Agreements/CreateAgreementOwnershipPercentage';
import CreateAgreementWorkForHire from './components/Agreements/CreateAgreementWorkForHire';
import CreateAgreementProducer from './components/Agreements/CreateAgreementProducer';
import AgreementTerms from './components/Agreements/AgreementTerms';
import CreateAgreementStandalone from './components/Agreements/CreateAgreementStandalone';
import CreateReview from './components/Create/CreateReview';
import AgreementPayment from './components/Agreements/AgreementPayment';

import CopyrightRegList from './pages/CopyrightRegList';
import CopyrightReg from './pages/CopyrightReg';
import CopyrightProductType from './components/Copyright/ProductType';
import CregType from './components/Copyright/CregType';
import WorkType from './components/Copyright/WorkType';
import MultipleWork from './components/Copyright/MultipleWork';
import SingleWorkType from './components/Copyright/SingleWorkType';
import MultipleWorkType from './components/Copyright/MultipleWorkType';
import SelectWork from './components/Copyright/SelectWork';
import Publish from './components/Copyright/Publish';
import Authors from './components/Copyright/Authors';
import SelectOtherMaterials from './components/Copyright/SelectOtherMaterials';
import Claimants from './components/Copyright/Claimants';
import ClaimantsTransfer from './components/Copyright/ClaimantsTransfer';
import OtherMaterials from './components/Copyright/OtherMaterials';
import AuthorizedAgent from './components/Copyright/AuthorizedAgent';
import CertificateRecipient from './components/Copyright/CertificateRecipient';
import Payment from './components/Copyright/Payment';
import SubmitForm from './components/Copyright/SubmitForm';
import Complete from './components/Copyright/Complete';

import Welcome from './pages/Welcome';
import CreateDeal from './pages/CreateDeal';
import DealDetail from './pages/DealDetail';
import SelectDealTeam from './components/Deals/SelectDealTeam';
import DealEdit from './components/Deals/DealEdit';

export default (
  <Route path="/" component={App}>
    <Route component={Auth}>
      <Route path="/login" component={Login} />
      <Route path="/logout" component={Logout} />
      <Route path="/signup" component={Signup} />
      <Route path="/signup/:key/:refId" component={Signup} />
      <Route path="/signup/:key/:refId/:plan/:planId" component={Signup} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route
        path="/password-reset/confirm/:uid/:token"
        component={ResetPassword}
      />
      <Route path="/confirm-email/:token" component={ConfirmEmail} />
      <Route
        path="/resend-verification-link"
        component={ResendVerificationLink}
      />
    </Route>

    <Route component={Main}>
      <IndexRoute component={Dashboard} />

      <Route path="/create" component={Create}>
        <IndexRoute component={ProductType} type="new" />
        <Route path="/create/new" component={ProductType} type="new" />
        <Route path="/create/exist" component={ProductType} type="exist" />
        <Route path="/create/product-props" component={ProductProps} />
        <Route path="/create/select-team" component={SelectTeam} />
        <Route
          path="/create/create-team"
          component={CreateTeam}
          type="create"
        />
        <Route path="/create/select-agreement" component={SelectAgreement} />
        <Route
          path="/create/agreement-ownership-split"
          component={CreateAgreementOwnershipSplit}
        />
        <Route
          path="/create/agreement-ownership-premium-split"
          component={CreateAgreementOwnershipPremiumSplit}
        />

        <Route
          path="/create/agreement-sound-recording-split-type/:page"
          component={CreateAgreementSoundRecordingSplitType}
        />

        <Route
          path="/create/agreement-ownership-percentage/:page"
          component={CreateAgreementOwnershipPercentage}
        />
        <Route
          path="/create/agreement-work-for-hire"
          component={CreateAgreementWorkForHire}
        />
        <Route
          path="/create/agreement-producer"
          component={CreateAgreementProducer}
        />
        <Route
          path="/create/agreement-terms/:prev/:type"
          component={AgreementTerms}
        />
        <Route
          path="/create/agreement-detail"
          component={AgreementDetail}
          type="create"
        />
        <Route
          path="/create/agreement-detail-split-update"
          component={AgreementDetailSplitUpdate}
        />
        <Route
          path="/create/review/:prev"
          component={CreateReview}
          type="create"
        />
        <Route path="/create/agreement/payment" component={AgreementPayment} />
      </Route>

      <Route path="/create-deal" component={CreateDeal}>
        <IndexRoute component={SelectDealTeam} />
        <Route
          path="/create-deal/create-team"
          component={CreateTeam}
          type="create-deal"
        />
        <Route
          path="/create-deal/agreement-standalone"
          component={CreateAgreementStandalone}
        />
      </Route>

      <Route path="/teams" component={Teams} />
      <Route path="/teams/create" component={CreateTeam} />
      <Route path="/teams/:teamId/detail" component={TeamDetail} />
      <Route path="/agreements" component={Agreements} />
      <Route
        path="/agreements/:agreementId/detail"
        component={AgreementDetail}
        type="agreement-detail"
      />
      <Route path="/dealroom/:dealId" component={DealDetail}>
        <Route path="/dealroom/:dealId/edit" component={DealEdit} page="edit" />
        <Route
          path="/dealroom/:dealId/review/:prev"
          component={DealEdit}
          page="review"
        />
      </Route>
      <Route path="/user" component={User} page="profile" />
      <Route path="/password" component={Password} />

      <Route path="/copyright-reg-list" component={CopyrightRegList} />
      <Route path="/copyright-reg" component={CopyrightReg}>
        <IndexRoute component={CopyrightProductType} />
        <Route path="/copyright-reg/copyright-type" component={CregType} />
        <Route path="/copyright-reg/work-type" component={WorkType} />
        <Route
          path="/copyright-reg/single-work-type/:prevPage"
          component={SingleWorkType}
        />
        <Route path="/copyright-reg/multiple-work" component={MultipleWork} />
        <Route
          path="/copyright-reg/multiple-work-type"
          component={MultipleWorkType}
        />
        <Route path="/copyright-reg/publish" component={Publish} />
        <Route path="/copyright-reg/select-work" component={SelectWork} />
        <Route path="/copyright-reg/authors" component={Authors} />
        <Route path="/copyright-reg/claimants" component={Claimants} />
        <Route
          path="/copyright-reg/claimants-transfer"
          component={ClaimantsTransfer}
        />
        <Route
          path="/copyright-reg/select-other-materials"
          component={SelectOtherMaterials}
        />
        <Route path="/copyright-reg/materials" component={OtherMaterials} />
        <Route
          path="/copyright-reg/authorized-agent"
          component={AuthorizedAgent}
        />
        <Route
          path="/copyright-reg/certificate-recipient"
          component={CertificateRecipient}
        />
        <Route path="/copyright-reg/payment" component={Payment} />
        <Route path="/copyright-reg/submit-form" component={SubmitForm} />
        <Route path="/copyright-reg/complete" component={Complete} />
      </Route>
    </Route>

    <Route component={Base}>
      <Route path="/welcome/:key" component={Welcome} />
      <Route path="/_dev" component={DevExample} />
      <Route path="/payment-test" component={PaymentTest} />
      <Route path="*" component={NotFound} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// src/routes.js